import React from 'react';
import styled from 'styled-components';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import DocumentViewer from './DocumentViewer';

const StyledDialogTitle = styled(DialogTitle)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export interface DocumentFullscreenDialogProps {
  open: boolean;
  storageKey: string;
  title?: string;
  fileSize?: number;
  onClose: () => void;
}

const DocumentFullscreenDialog: React.FC<
  DocumentFullscreenDialogProps
> = props => {
  const { open, storageKey, title, fileSize, onClose } = props;
  return (
    <Dialog fullScreen open={open} onClose={onClose}>
      <StyledDialogTitle disableTypography>
        <Typography variant='h2'>{title}</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </StyledDialogTitle>
      <DialogContent>
        <DocumentViewer
          storageKey={storageKey}
          title={title}
          fileSize={fileSize}
        />
      </DialogContent>
    </Dialog>
  );
};

export default DocumentFullscreenDialog;
